import { supabaseClient } from "supabase/supabase";

export const queryVenueByID = async ({ uid }: { uid: string }) => {
  const query = supabaseClient.from("venues").select("*").eq("uid", uid);

  const { data, error } = await query;
  if (error) {
    throw error;
  }
  return data![0];
};
